import * as yup from 'yup';

const EditProfileValidationSchema = yup.object().shape({
	first_name: yup
		.string()
		.trim()
		.required('First name is required')
		.min(2, 'First name must be at least 2 characters')
		.max(255, 'First name must be less than 255 characters'),
	last_name: yup
		.string()
		.trim()
		.required('Last name is required')
		.min(2, 'Last name must be at least 2 characters')
		.max(255, 'Last name must be less than 255 characters'),
});

const ChangePasswordValidationSchema = yup.object().shape({
	current_password: yup
		.string()
		.trim()
		.required('Current password is required'),
	new_password: yup
		.string()
		.trim()
		.required('New password is required')
		.min(8, 'Password must be at least 8 characters'),
	repeat_new_password: yup
		.string()
		.trim()
		.required('Repeat new password is required')
		.oneOf([yup.ref('new_password')], 'Passwords must match'),
});

export { EditProfileValidationSchema, ChangePasswordValidationSchema };
